import { useIntl } from "react-intl";
import { Button } from "../BP2Components";
import Select from "react-select";
import projectConfig from "../../projectConfig.json";

export const AddNewParticipantToPhoneCall = ({ users }) => {
   const intl = useIntl();

   const usersToOptions = users.map((user) => {
      return { value: user.number, label: user.number };
   });

   const customStyles = {
      control: (baseStyles, state) => ({
         ...baseStyles,
         "&:hover": { borderColor: projectConfig?.cssVariables?.["--btn-primaryBackground"] },
         borderColor: state.isFocused
            ? projectConfig?.cssVariables?.["--btn-primaryBackground"]
            : projectConfig?.cssVariables?.["--btn-defaultBorder"],
         boxShadow: "none",
      }),
      menuList: (provided) => ({
         ...provided,
         overflowX: "hidden",
      }),
      option: (provided, state) => ({
         ...provided,
         minHeight: "32px",
         backgroundColor: state.isFocused
            ? projectConfig.cssVariables["--btn-primaryBackground"]
            : state.isSelected
              ? projectConfig.cssVariables["--btn-primaryBackground"]
              : "transparent",
         color:
            state.isSelected || state.isFocused
               ? projectConfig.cssVariables["--nav-background"]
               : "inherit",
         ":active": {
            ...provided[":active"],
            backgroundColor: projectConfig.cssVariables["--btn-primaryBackground"],
         },
      }),
      menu: (base) => ({
         ...base,
         position: "absolute",
         marginTop: 4,
      }),
      menuPortal: (base) => ({
         ...base,
         zIndex: 9999,
         position: "fixed",
      }),
      singleValue: (base) => ({
         ...base,
         transform: "none",
         position: "relative",
      }),
   };

   return (
      <div className="call-manager__add-phone-number">
         <label className="call-manager__add-phone-number-label">
            {intl.formatMessage({ id: "callManager.selectClient" })}
         </label>
         <Select
            options={usersToOptions}
            placeholder={intl.formatMessage({ id: "callManager.addPhoneNumber" })}
            styles={customStyles}
         />
         <Button buttonType="primary">
            {intl.formatMessage({ id: "callManager.addParticipant" })}
         </Button>
      </div>
   );
};
